import { useQuery } from "@tanstack/react-query";
import { getAnonKey, getEdgeFunctionUrl } from "@/utils/supabaseUrl";
import type { SnapshotPayload } from "@/components/finance/reports/shared/snapshotSerialize";

export type PublicSnapshot = {
  id: string;
  title: string | null;
  dateFrom: string | null;
  dateTo: string | null;
  currencies: string[];
  generatedAt: string;
  payload: SnapshotPayload;
};

/**
 * Fetch a frozen investor report snapshot from the public (no-JWT) edge
 * function. Anonymous — uses only the anon apikey, no user session.
 */
export function usePublicInvestorReport(token: string | undefined) {
  return useQuery({
    queryKey: ["public-investor-report", token],
    enabled: !!token,
    retry: false,
    staleTime: Infinity, // snapshot never changes
    queryFn: async () => {
      const res = await fetch(
        `${getEdgeFunctionUrl("public-investor-report")}?token=${encodeURIComponent(token!)}`,
        { headers: { apikey: getAnonKey(), "Content-Type": "application/json" } }
      );
      if (res.status === 404) throw new Error("NOT_FOUND");
      if (!res.ok) throw new Error("Failed to load report");
      return (await res.json()) as PublicSnapshot;
    },
  });
}
